/**
 * Translates a boolean value to the application's standard yes/no i18n labels.
 * Centralised here so the table cell renderer and the detail-page field
 * resolver always produce the same output.
 *
 * Accepts any callable that maps a key to a string so it is compatible with
 * both the full i18next TFunction and the narrower `(k: string) => string`
 * signatures used in utility helpers.
 */
export function formatBoolean(value: boolean, t: (key: string) => string): string {
  return value ? t('table.filter.yes') : t('table.filter.no');
}
